import { Label } from "@/components/ui/label";
import { Slider } from "@/components/ui/slider";
import { Switch } from "@/components/ui/switch";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";

export const OFFSITE = { block: "Block off-site clock-in", flag: "Allow, but flag for review", allow: "Allow without flag" };

export const GeofenceControls = ({ value, onChange, idPrefix = "geo" }) => (
  <div className="space-y-5" data-testid={`${idPrefix}-controls`}>
    <div>
      <div className="flex justify-between"><Label>Geofence radius</Label><span className="font-mono-num text-sm font-bold text-[#00A85C]" data-testid={`${idPrefix}-radius-value`}>{value.geofence_radius_m} m</span></div>
      <Slider value={[value.geofence_radius_m]} min={25} max={1000} step={5} onValueChange={(v) => onChange({ geofence_radius_m: v[0] })} className="mt-3" data-testid={`${idPrefix}-radius-slider`} />
    </div>
    <div className="flex items-center justify-between rounded-xl border border-slate-200 p-3">
      <div><p className="text-sm font-medium">Location verification</p><p className="text-xs text-slate-500">Check location when staff clock in or out.</p></div>
      <Switch checked={value.location_verification} onCheckedChange={(v) => onChange({ location_verification: v })} data-testid={`${idPrefix}-verify-switch`} />
    </div>
    <div className="space-y-1.5">
      <Label>Off-site clock-in policy</Label>
      <Select value={value.offsite_policy} onValueChange={(v) => onChange({ offsite_policy: v })}>
        <SelectTrigger className="h-11 rounded-xl" data-testid={`${idPrefix}-offsite-select`}><SelectValue /></SelectTrigger>
        <SelectContent>{Object.entries(OFFSITE).map(([k, l]) => <SelectItem key={k} value={k}>{l}</SelectItem>)}</SelectContent>
      </Select>
    </div>
  </div>
);
